import {IFilterFilter} from 'angular';
import {IForecastType} from '../../api/api.types';
import {IStationApi} from '../../api/station-api.service';


export interface IForecastingService {
  getForecastModelMethods(): string[];
  getForecastModelMethodParameters(method: string): any[];
  getForecastModelParameters(): any[];
}

export class ForecastingService implements IForecastingService {
  static $inject = ['$filter', 'stationApi'];

  private filter: IFilterFilter;
  private forecastTypes: IForecastType[];
  private forecastModelMethods: string[] = ['LinearRegression', 'Lasso', 'ExtraTreesRegressor'];
  private forecastModelMethod = {
    modelName: 'method', 
    label: 'Method',
    type: 'select', 
    options: [
      {
        name: 'LinearRegression',
        params: [
          {
            name: 'fit_intercept',
            type: 'boolean'
          }
        ]
      },
      {
        name: 'Lasso',
        params: [
          {
            name: 'alpha',
            type: 'float',
            min: 0,
            max: 1
          }
        ]
      },
      {
        name: 'ExtraTreesRegressor',
        params: [
            {
              name: 'n_estimators',
              type: 'number',
              min: 1,
              max: 40
            },
            {
              name: 'random_state',
              type: 'number',
              min: 1,
              max: 9
            }
        ]
      }
     ]
  };
  private nonSeasonalParams = [
    // {
    //   modelName: 'featureData',
    //   label: 'Feature data', 
    //   type: 'multi-select', 
    //   options: ['discharge', 'precipitation', 'temperature', 'snow data']
    // },
    // {
    //   modelName: 'featureTimelag',
    //   label: 'Feature timelag',
    //   type: 'number',
    //   min: 1,
    //   max: 10,
    //   default: 1
    // },
    {
      modelName: 'multimodel',
      label: 'multimodel',
      type: 'boolean',
      default: false
    }
  ];
  private forecastModelParams: any = {
    'pentadal': {
      params: this.nonSeasonalParams
    },
    'decade': {
      params: this.nonSeasonalParams
    },
    'monthly': {
      params: this.nonSeasonalParams
    },
    'seasonal': {
      params: [
        // {
        //   modelName: 'ensembleSize',
        //   label: 'Ensemble size',
        //   type: 'number',
        //   min: 1,
        //   max: 1000,
        //   default: 20
        // },
        // {
        //   modelName: 'featureLimit',
        //   label: 'Feature limit per model',
        //   type: 'number',
        //   min: 1,
        //   max: 4,
        //   default: 2
        // },
        // {
        //   modelName: 'featureData',
        //   label: 'Feature data',
        //   subparams: ['Qm','Pm', 'Tm', 'Sm']
        // }
        {
          modelName: 'earliestMonth',
          label: 'Earliest month',
          type: 'number',
          min: 1,
          max: 12,
          default: 1
        },
        {
          modelName: 'nModel',
          label: 'nModel',
          type: 'number',
          min: 1,
          max: 100,
          default: 1
        },
        {
          modelName: 'maxFeatures',
          label: 'maxFeatures',
          type: 'number',
          min: 1,
          max: 4,
          default: 1
        }
      ]
    }
   };

  constructor(
    $filter: ng.IFilterService,
    private stationApi:IStationApi, 
  ) {
    this.filter = $filter('filter');
  }

  getForecastModelMethods() {
    return this.forecastModelMethods;
  }

  getForecastModelMethodParameters(method: string) {
    return this.filter(this.forecastModelMethod.options, {name: method});
  }

  getForecastModelParameters() {
    return this.forecastModelParams;
  }

}

export default ForecastingService;


/** WEBPACK FOOTER **
 ** ./app/station/forecast-model/forecast-model.service.ts
 **/